<template>
  <div class="AblitySet">
    <div class="top">
      <div class="t_l">
        <div class="t_l_item open-switch-box">
          <span style="margin-right: 8px">能力匹配</span>
          <a-switch v-if="editForm" v-model="openSetting" />
          <span v-else style="margin-right: 8px">：{{ openSetting ? '开启' : '关闭' }}</span>
        </div>
        <div class="t_l_item">
          <span>二级能力无数据时候是否匹配一级能力</span>
          <span v-if="!editForm">：{{ UseFirstAbility ? '是' : '否' }}</span>
          <a-select v-else allowClear v-model="UseFirstAbility" placeholder="请选择" style="width: 170px; margin-left: 15px">
            <a-select-option :value="false">否</a-select-option>
            <a-select-option :value="true">是</a-select-option>
          </a-select>
        </div>
        <div class="t_l_item">
          <span>多能力取值</span>
          <span v-if="!editForm">：{{ MultipleAbilitySocreProcessType == 1 ? '最小值' : '最大值' }}</span>
          <a-select v-else allowClear v-model="MultipleAbilitySocreProcessType" placeholder="请选择" style="width: 170px; margin-left: 15px">
            <a-select-option :value="1">最小值</a-select-option>
            <a-select-option :value="2">最大值</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="t_r">
        <template v-if="editForm">
          <a-button style="margin-right: 8px" type="primary" @click="addLevel">新建匹配</a-button>
          <a-button style="margin-right: 8px" type="primary" @click="importLevel">导入匹配</a-button>
          <a-popconfirm v-permission="`Content.MatchSeting.AbilityDeleteAll`" title="是否清空当前所有设置?" ok-text="是" cancel-text="否" @confirm="clearSet">
            <a-button type="primary">重置设置</a-button>
          </a-popconfirm>
        </template>
      </div>
    </div>
    <div class="bottom tableForm" v-auth="`Content.MatchSeting.AbilitySave`">
      <a-form-model ref="tableForm" :model="tableForm" labelAlign="right">
        <a-table :columns="columns" :data-source="tableForm.dataSource" :pagination="false" bordered size="middle">
          <div slot="minScore" slot-scope="text, record, index">
            <span v-if="!editForm">{{ record.minScore }}</span>
            <a-form-model-item v-else :prop="`dataSource[${index}].minScore`" label="" :rules="tableFormRules()">
              <a-input-number v-model="record.minScore" :precision="0" :min="50" :max="150" />
            </a-form-model-item>
          </div>
          <div slot="maxScore" slot-scope="text, record, index">
            <span v-if="!editForm">{{ record.maxScore }}</span>
            <a-form-model-item v-else label="" :prop="`dataSource[${index}].maxScore`" :rules="tableFormRules()">
              <a-input-number v-model="record.maxScore" :precision="0" :min="record.minScore || 50" :max="150" />
            </a-form-model-item>
          </div>
          <div slot="level" slot-scope="text, record">
            <a-select :disabled="!editForm" v-model="record.levelSign" :key="record.levelSign" :default-value="record.levelSign" placeholder="请选择关卡" style="width: 100%">
              <template v-for="item in levelList">
                <a-select-option v-if="item.levelName != '练习关'" :value="item.levelSign" :text="item.levelName" :key="item.id" @click="getRecord(item, record)">{{ item.levelName }}</a-select-option>
              </template>
            </a-select>
          </div>
          <div slot="action" slot-scope="text, record">
            <a href="#" v-if="editForm" style="color: #f00" @click="removeLevel(record)">删除</a>
          </div>
        </a-table>
      </a-form-model>

      <div class="subBox" v-permission="`Content.MatchSeting.AbilitySave`">
        <a-button v-if="editForm" type="primary" @click="submit()">保存</a-button>
        <a-button v-else type="primary" @click="edit()">编辑</a-button>
      </div>
    </div>
    <AddLeveModal ref="AddLeveModalRef" :levelList="levelList" :dataList="this.tableForm.dataSource" />
    <ImportMdoal
      ref="ImportMdoalRef"
      :download-name="$route.query.name + '能力匹配规则'"
      :template-url="`${$data._templatePath}/template/excel/matchSeting_template.xlsx`"
      title="导入匹配"
      :toJson="true"
    />
  </div>
</template>

<script>
import AddLeveModal from './addLeveModal'
import ImportMdoal from '@/components/ImportModal/index.vue'
import { saveMatchSetting, getMatchSetting } from '@/utils/http'
import defaultLevel from './defaultLevel'

const columns = [
  {
    title: '游戏原始分范围',
    align: 'center',
    children: [
      {
        title: '最低分',
        dataIndex: 'minScore',
        align: 'center',
        scopedSlots: { customRender: 'minScore' },
        key: 'minScore',
      },
      {
        title: '最高分',
        dataIndex: 'maxScore',
        scopedSlots: { customRender: 'maxScore' },
        align: 'center',
        key: 'maxScore',
      },
    ],
  },
  { title: '初始关卡设置', key: 'level', scopedSlots: { customRender: 'level' }, align: 'center' },
  {
    title: '',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center',
  },
]

const importColumn = {
  '测评原始分最高分数（50-150整数）': 'maxScore',
  '测评原始分最低分数（50-150整数）': 'minScore',
  '关卡（1-50整数）': 'levelSign',
}

const tableFormRules = () => [{ required: true, message: '请填写内容', trigger: 'blur' }]
export default {
  name: 'AblitySet',
  components: { AddLeveModal, ImportMdoal },
  inject: ['setIsSave'],
  data() {
    return {
      columns,
      tableForm: {
        dataSource: [],
      },
      editForm: false,
      abilityEvaluationSysId: '',
      gameId: '',
      pageIndex: 1,
      pageSize: 10,
      levelList: [],
      contentName: '',
      detailList: [],
      UseFirstAbility: false,
      MultipleAbilitySocreProcessType: 2,
      openSetting: false,
      queryList: [],
    }
  },
  created() {
    Promise.all([this.GetAbilityevaluationsys(), this.levelSelect()]).then(() => {
      this.getMatchSettingInfo()
    })
  },
  methods: {
    removeLevel(record) {
      this.tableForm.dataSource = this.tableForm.dataSource.filter((v) => v.id != record.id)
    },
    async importLevel() {
      const data = await this.$refs['ImportMdoalRef'].showModal()
      const keys = Object.keys(importColumn)
      const dataSource = []
      const total = data.length
      for (let i = 0; i < data.length; i++) {
        const item = data[i]
        const result = {}
        let error = false
        keys.forEach((key) => {
          const rkey = importColumn[key]
          const val = item[key]
          if (Object.prototype.toString.call(val).slice(8, -1) != 'Number') {
            error = true
          }
          result[rkey] = val
        })
        if (result.levelSign > this.levelList.length || result.levelSign > 41) {
          error = true
        }
        if (result.maxScore > 150 || result.minScore < 50) {
          error = true
        }
        if (!error) {
          result.id = i + +new Date()
          dataSource.push(result)
        }
      }

      const errorLen = total - dataSource.length
      this.tableForm.dataSource = dataSource
      this.tableForm.dataSource = this.tableForm.dataSource.sort((a, b) => {
        return Number(a.maxScore) - Number(b.maxScore)
      })
      const msgType = errorLen ? 'error' : 'success'
      this.$message[msgType](`${errorLen ? '部分数据有误' : '全部导入成功'}：本次需导入数据${total}条，其中成功${dataSource.length}条，失败${errorLen}条`)
    },
    async addLevel() {
      const data = await this.$refs['AddLeveModalRef'].showMdoal()
      console.log(data)
      this.tableForm.dataSource.push(...data)
      this.tableForm.dataSource = this.tableForm.dataSource.sort((a, b) => {
        return Number(a.maxScore) - Number(b.maxScore)
      })
    },
    tableFormRules,
    repeatScoreValidator(data = []) {
      const tableSet = new Set()
      const setScore = (min, max) => {
        for (let i = min; i <= max; i++) {
          if (tableSet.has(i)) {
            return false
          } else {
            tableSet.add(i)
          }
        }
        return true
      }
      data = data.concat(this.tableForm.dataSource)
      return data.some((item) => {
        const isRepeat = setScore(+item.minScore, +item.maxScore)
        return !isRepeat
      })
    },
    edit() {
      this.editForm = true
      this.setIsSave(false)
    },
    initDefaultConfig() {
      const dataSource = []
      const len = defaultLevel.length
      for (let i = 0; i < Math.min(len, 41); i++) {
        const item = {
          ...defaultLevel[i],
          levelSign: i + 1,
          id: i,
        }
        dataSource.push(item)
      }
      this.tableForm.dataSource = dataSource
    },
    async getMatchSettingInfo() {
      const { data } = await getMatchSetting({
        contentId: this.$route.query.id,
        settingType: 2,
      })
        const { id, useFirstAbility, settingDetails, multipleAbilitySocreProcessType, status } = data.data || {}
        if (!settingDetails?.length) {
          this.initDefaultConfig()
        } else {
          this.tableForm.dataSource = settingDetails?.map((v, i) => ({
            levelSign: v.levelSign,
            minScore: v.minStandard,
            maxScore: v.maxStandard,
            id: i,
          }))
          if (settingDetails.length < 41) {
            const append = defaultLevel.slice(settingDetails.length).map((v, i) => ({
              ...v,
              levelSign: i + settingDetails.length + 1,
              id: +new Date() + i,
            }))
            console.log(defaultLevel.slice(settingDetails.length))
            this.tableForm.dataSource = this.tableForm.dataSource.concat(append)
            console.log(this.tableForm.dataSource)
          }
        }
        this._settingId = id
        this.openSetting = status || false
        this.UseFirstAbility = useFirstAbility || false
        this.MultipleAbilitySocreProcessType = multipleAbilitySocreProcessType == 0 ? 2 : multipleAbilitySocreProcessType || 2
    },
    //获取能力体系ID
    GetAbilityevaluationsys() {
      return this.$http.ReportService.getAbilityEvaluationSys().then((res) => {
        this.abilityEvaluationSysId = res.data[0].id
        return res
      })
    },
    getRecord(item, record) {
      this.queryList.forEach((el) => {
        if (el.abilityLevelConfigId == record.id) {
          el.abilityLevelConfigId = record.id
          el.gameLevelMatchSettingDetailId = record.levelId
          el.levelSign = item ? item.levelSign : '-1'
        }
      })
    },
    async submitValidate() {
      this.$message.destroy()
      return new Promise((reslove, reject) => {
        if (!this.contentName) {
          this.$confirm({
            title: '未关联测评游戏',
            content: '未关联测评游戏，是否退出编辑？ 退出后游戏匹配规则不生效',
            onOk() {
              reslove()
            },
            onCancel() {
              reject()
            },
          })
        } else {
          reslove()
        }
      })
    },
    // 保存
    async submit() {
      this.$refs['tableForm'].validate(async (valid) => {
        if (!valid) return
        if (this.repeatScoreValidator()) {
          return this.$message.error('分数范围重复')
        }
        let params = {
          id: this._settingId,
          contentId: this.$route.query.id,
          settingType: 2,
          useFirstAbility: this.UseFirstAbility,
          multipleAbilitySocreProcessType: this.MultipleAbilitySocreProcessType,
          status: this.openSetting,
          settingDetails: this.tableForm.dataSource.map((v) => ({
            levelSign: v.levelSign,
            minStandard: v.minScore,
            maxStandard: v.maxScore,
          })),
        }
        const { data } = await saveMatchSetting(params)
          this.$message.success(data.message)
          this.editForm = false
          this.setIsSave(true)
       
      })
    },
    getmatchinfo(isSecond) {
      let params = {
        contentId: this.$route.query.id,
        settingType: 2,
      }
      this.$http.getmatchinfo(params).then((res) => {
        // 如果有数据，渲染表格，否则默认设置体系渲染表格
        if ( res.data.data) {
          this.MultipleAbilitySocreProcessType = res.data.data.multipleAbilitySocreProcessType == 0 ? 2 : res.data.data.multipleAbilitySocreProcessType
          this.UseFirstAbility = res.data.data.useFirstAbility ? true : false
          this.matchList()
          this.contentName = res.data.data.contentName
          this.gameId = res.data.data.id
          this.detailList = res.data.data.detailList
          this.detailList.forEach((item) => {
            let str = {}
            str.abilityLevelConfigId = item.abilityLevelConfigId
            str.gameLevelMatchSettingDetailId = item.id
            str.levelSign = item.levelSign
            this.queryList.push(JSON.parse(JSON.stringify(str)))
          })
          if (res.data.data.abilityEvaluationSysId !== this.abilityEvaluationSysId) {
            let obj = {
              ContentId: +this.$route.query.id,
              AbilityEvaluationSysId: this.abilityEvaluationSysId,
              SettingType: 2,
            }
            this.$http.updategameconfig(obj).then(() => {
              if (!isSecond) {
                this.getmatchinfo(1)
              }
            })
          }
        } else {
          //参照原后台代码
          // 默认设置一个体系
          let SysId = this.abilityEvaluationSysId
          let obj = {
            ContentId: +this.$route.query.id,
            AbilityEvaluationSysId: SysId,
            SettingType: 2,
          }
          this.$http.updategameconfig(obj).then((resBy) => {
            const { status, data, message } = resBy.data
            if (!isSecond) {
              this.getmatchinfo(1)
            }
          })
        }
      })
    },
    matchList() {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        abilityEvaluationSysId: this.abilityEvaluationSysId,
      }
      this.$http.matchList(params).then(() => {
        if (this.levelList.length) {
          this.detailList.forEach((item) => {
            this.tableForm.dataSource.forEach((el) => {
              if (item.abilityLevelConfigId == el.id) {
                //   el.levelSign = item.levelSign
                el.levelSign = item.levelSign == -1 ? undefined : item.levelSign
                el.levelId = item.id
              }
            })
          })
        } else {
          this.detailList.forEach((item) => {
            this.tableForm.dataSource.forEach((el) => {
              if (item.abilityLevelConfigId == el.id) {
                //   el.levelSign = item.levelSign == 0 ? -1 : item.levelSign;
                el.levelSign = item.levelSign == -1 ? undefined : item.levelSign
                el.levelId = item.id
              }
            })
          })
        }
      })
    },
    levelSelect() {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('tainGameId', this.$route.query.id)
        this.$http.levelSelect(formData).then((res) => {
            this.levelList = res.data.data.filter((v) => v.levelName != '练习关').slice(0, 41)
            resolve()
          reject()
        })
      })
    },
    // 清空设置
    clearSet() {
      this.initDefaultConfig()
      ;(this.UseFirstAbility = false), (this.MultipleAbilitySocreProcessType = 2)
      this.openSetting = false
    },
  },
}
</script>

<style scoped>
/deep/ .searchForm {
  display: flex;
}

/deep/ .searchForm .fold {
  width: 91%;
  display: flex;
}
</style>
<style scoped lang="less">
.tableForm {
  ::v-deep .ant-form-item {
    margin-bottom: 0px;
  }
}
.top {
  display: flex;
  justify-content: space-between;
  .t_l {
    display: flex;
    align-items: center;
    .open-switch-box {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .t_l_item {
      margin-left: 30px;
    }
    .ant-btn-primary {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      margin-left: 20px;
    }
    em {
      color: #d2d2d2;
      font-size: 14px;
      font-style: normal;
      margin-left: 15px;
      cursor: pointer;
    }
  }
}

.bottom {
  margin-top: 15px;
}

.subBox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  position: fixed;
  z-index: 10;
  bottom: 0;
  right: 35px;
  background: #fff;
  padding: 8px 0;
  width: calc(100% - 15% - 48px - 256px);
}
</style>
